import { action, observable } from 'mobx';

export default class AsyncOperation<T, TError = Error> {
  // Expose a no-op async operation, useful as a default
  static resolved = new AsyncOperation(Promise.resolve());

  @observable public error: TError | undefined;

  @observable public originalPromise: Promise<T>;

  @observable public promise: Promise<T | undefined>;

  @observable public result: T | undefined;

  @observable public running: boolean = true;

  constructor(promise: Promise<T>) {
    this.originalPromise = promise;
    this.running = true;

    this.promise = (async () => {
      try {
        const result = await promise;

        this.setResult(result);

        return result;
      } catch (ex) {
        this.setError(ex);
      } finally {
        this.setRunning(false);
      }

      return;
    })();
  }

  @action
  private setResult(result: T): void {
    this.result = result;
  }

  @action
  private setError(error: TError): void {
    this.error = error;
  }

  @action
  private setRunning(running: boolean): void {
    this.running = running;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/AsyncOperation.ts